import { dashboardT } from '../../../../lib/messages';
import type { dashboardCanvasRendererProps } from '@/components/dashboard/DashboardCanvas';
import type { networkDashboardRuntime } from './widgetRuntime';
import { NetworkDashboardWidgetType, type NetworkDashboardWidget } from './widgetModel';

export function NetworkSectionHeadingRenderer({
  widget,
}: dashboardCanvasRendererProps<NetworkDashboardWidget, networkDashboardRuntime>) {
  if (widget.type !== NetworkDashboardWidgetType.SectionHeading) {
    return null;
  }
  return <h2 className="text-lg font-semibold">{dashboardT('networkDashboard.demandSources')}</h2>;
}
